import { FaqQuestion } from '../../common';
import { FaqQuestionViewModel } from '../../public-api';

export const mapLocalizedQuestionsToQuestions = (faqQuestions: FaqQuestion[], lang: string): FaqQuestionViewModel[] => {
  return faqQuestions.map((questionItem) => ({
    ...questionItem,
    question: questionItem.question[lang],
    answer: questionItem.answer[lang],
  }));
};
